import React from "react";
import "../styles/stomach.css";
import CardServices from "./cardServices";
import CardServicesMS from "./cardServicesMS";
import CardServicesWB from "./cardServicesWB";
import CardServicesYM from "./cardServicesYM";
import CardServicesDF from "./cardServicesDF";


function CarouselServices() {
  return (
    <div>
      <div className="carouselTitle">What We Do</div>

      <div className="container1">
        <CardServicesYM
        
          description={
            "Academy for Science and Technology introduces kids to the fun aspects of science, technology, engineering, art and math.  "
          }
          image={"./images/YouthMaker.png"}
        />
         <CardServicesWB
        
          description={
            "We provide hands-on courses for engineering students and professionals in different technological fields."
          }
          image={"./images/formationMakerCV.jpg"}
        />
        <CardServicesDF
          description={
            "Fabrication services including 3D Printing, CNC Routing, Laser Cutting and PCB Fabrication."
          }
          image={"./images/act3DMaker.jpg"}
        />
       

        <CardServicesMS
          description={
            "Provider of educational robotic kits, electronics tools, IT equipments and a lot more."
          }
          image={"./images/makershop.png"}
        />
      </div>
    </div>
  );
}

export default CarouselServices;
